import { type MutationOptions, useMutation } from 'react-query'

import agent from 'agent'
import useAuth from 'hooks/use-auth'
import { clientsMutationKeys } from 'queries/clients/query-keys'
import { getEndpointWithParams } from 'queries/queries-utils'

function activateClient([endpoint, params]: ReturnType<
  typeof clientsMutationKeys.putClientsActivate
>) {
  return async () => {
    const endpointWithParams = getEndpointWithParams(endpoint, params)

    await agent.put(endpointWithParams)
  }
}

export const usePutClientsActivate = (
  identifier: string,
  options?: Omit<MutationOptions, 'mutationKey' | 'mutationFn'>
) => {
  const { currentTeamId: teamId } = useAuth()

  const queryParams = {
    identifier,
    teamId
  }

  const mutationKey = clientsMutationKeys.putClientsActivate(queryParams)

  return useMutation({
    ...options,
    mutationKey,
    mutationFn: activateClient(mutationKey)
  })
}
